import { getSectionProps } from 'utils/styles';
import { CompareProps } from './types';
import RichTextTable from 'components/shared/RichTextTable/RichTextTable';

const Compare = ({ sectionName, content, color, margins, highlightedColumnIndex, highlightColor }: CompareProps) => {
  return (
    <section {...getSectionProps(color, margins, sectionName)}>
      <div className="content-wrapper">
        <RichTextTable
          content={content}
          color={color}
          highlightedColumnIndex={highlightedColumnIndex}
          highlightColor={highlightColor}
        />
      </div>
    </section>
  );
};
export default Compare;
